import UsersGroupDetailModal from './UsersGroupDetailModal';
export default UsersGroupDetailModal;
